import i18n from "@/plugins/vue-i18n";

const AdminCampaigns = () =>
  import(/* webpackChunkName: "campaigns" */ "@/views/admin/campaigns/index/CampaignIndexPage.vue");
const AdminCampaignEdit = () =>
  import(/* webpackChunkName: "campaigns" */ "@/views/admin/campaigns/edit/CampaignEditPage.vue");
const AdminCampaignCreatives = () =>
  import(
    /* webpackChunkName: "campaigns" */ "@/views/admin/campaigns/creatives/index/CampaignCreativeIndexPage.vue"
  );
const AdminCampaignCreativeAdd = () =>
  import(
    /* webpackChunkName: "campaigns" */ "@/views/admin/campaigns/creatives/add/CampaignCreativeAddPage.vue"
  );

const campaigns = [
  {
    path: "campaigns",
    name: "AdminCampaigns",
    component: AdminCampaigns,
    meta: {
      title: i18n.t("title.campaigns"),
    },
  },
  {
    path: "campaigns/:id/edit",
    name: "AdminCampaignEdit",
    component: AdminCampaignEdit,
    meta: {
      title: i18n.t("title.campaign"),
    },
  },
  {
    path: "campaigns/:id/related-creatives",
    name: "AdminCampaignCreatives",
    component: AdminCampaignCreatives,
    meta: {
      title: i18n.t("title.creatives"),
    },
  },
  {
    path: "campaigns/:id/related-creatives/add",
    name: "AdminCampaignCreativeAdd",
    component: AdminCampaignCreativeAdd,
    meta: {
      title: i18n.t("title.creativeAdd"),
    },
  },
];

export default campaigns;
